// Web setup: patches NativeModules before any app code runs
import { NativeModules } from 'react-native';
import AudioRecorder from './shims/react-native-audio-recorder';

// Inject web implementations into NativeModules
NativeModules.AudioRecorder = AudioRecorder;
